/// <reference types="node" />
export var CLIENT_VERSION = "5.3.0";